<template lang="pug">
.v-base-slider.base-slider(:key="isTablet" :class="[autoplayOn ? 'autoplay' : '', swiper?.slides?.length < 2 || swiper?.isLocked  ? 'disable-buttons' : '']")
	v-swiper-slider(
		:options="options"
		:navigation="computedNavigation"
		:key="uniqueId"
		:pagination="options.pagination"
		:ref="`swiperSlider-${uniqueId}`"
		@init="handlerSwiperInit"
	)
		slot
	button.swiper-arrow.swiper-button-prev(type="button" aria-label="prev" ref="prev" :class="[`${uniqueId}`, `swiper-arrow--${theme}`]")
		v-svg-icon.swiper-arrow__icon(icon="chevron-left")
	button.swiper-arrow.swiper-button-next(type="button" aria-label="next" ref="next" :class="[`${uniqueId}`, `swiper-arrow--${theme}`]")
		v-svg-icon.swiper-arrow__icon(icon="chevron-right")
	.swiper-pagination(v-if="options.pagination && !swiper?.isLocked" :style="{animationDuration: animationDuration}")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import uniqueId from '../scripts/helpers/uniqueId.js';
import isMobMixin from "../components/mixins/v-mixin-is-mob.vue";

export default {

	mixins: [
		sourceMixin,
		isMobMixin
	],

	props: {
		options: {
			type: Object,
			default: null
		},
		theme: {
			type: String,
			default: null
		}
	},

	data() {
		return {
			swiper: null,
			slider: {},
			uniqueId: uniqueId('swiper-')
		};
	},

	computed: {
		computedNavigation() {
			return {
				prevEl: `.swiper-button-prev.${this.uniqueId}`,
				nextEl: `.swiper-button-next.${this.uniqueId}`
			};
		},

		animationDuration() {
			return `${this.swiper?.params?.autoplay?.delay}ms`
		},

		autoplayOn() {
			return this.swiper?.params?.autoplay?.enabled
		}
	},

	methods: {
		dataSet(data) {
			this.slider = data;
		},

		handlerSwiperInit(swiper) {
			this.swiper = swiper;
		}
	}
};
</script>